export const AUTH_TOKEN_URL = `${process.env.VUE_APP_AUTH_TOKEN_URL}`;
export const AUTH_ENDPOINT = `${process.env.VUE_APP_AUTH_ENDPOINT}`;
export const EXAMS_ENDPOINT = `${process.env.VUE_APP_EXAMS_ENDPOINT}`;
export const URl_TOKEN = `${process.env.VUE_APP_URL_TOKEN_ENDPOINT}`;
export const AUTH_GENERATE =  `${process.env.VUE_APP_AUTH_GENERATE_ENDPOINT}`;
export const AUTH_VALIDATE = `${process.env.VUE_APP_AUTH_VALIDATE_ENDPOINT}`;